export class MemoPaymentSimpleView {
    constructor(
        public memoStatus: string,
        public customerId: number
    ) {}
}